import { creators } from '@/mocks/home';

export default function CreatorShowcase() {
  return (
    <section className="w-full py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mb-3">
            热门创作者
          </h2>
          <p className="text-sm text-foreground-500 max-w-xl mx-auto">
            与千万优秀创作者一起，发现更多有趣的内容和故事
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {creators.map((creator, idx) => (
            <div
              key={idx}
              className="bg-background-50 rounded-2xl p-6 text-center border border-background-200/60 transition-all duration-300 hover:scale-[1.02]"
            >
              <img
                src={creator.avatar}
                alt={creator.name}
                className="w-20 h-20 rounded-full object-cover mx-auto mb-4 border-2 border-primary-200"
              />
              <h3 className="font-heading text-lg text-foreground-950 mb-1">{creator.name}</h3>
              <p className="text-sm text-primary-500 font-medium mb-2">{creator.category}</p>
              <p className="text-xs text-foreground-500 mb-3 leading-relaxed">{creator.description}</p>
              <div className="flex items-center justify-center gap-1 text-sm text-foreground-400">
                <i className="ri-user-star-line text-primary-400"></i>
                <span className="font-medium text-foreground-700">{creator.followers}</span>
                <span>粉丝</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}